import { useEffect } from "react";
import { useLocation } from "wouter";
import * as GA from "@/utils/googleAnalytics";

/**
 * Hook to automatically track page views with Google Analytics
 * Should be used in the main App component
 */
export const useGoogleAnalytics = () => {
  const [location] = useLocation();

  useEffect(() => {
    // Track page view when location changes
    const url = window.location.href;
    const title = document.title;

    GA.trackPageView(url, title);
  }, [location]);
};

/**
 * Manual page view tracking for specific components
 * @param pageTitle - Custom page title
 * @param customUrl - Custom URL (optional)
 */
export const usePageView = (pageTitle?: string, customUrl?: string) => {
  useEffect(() => {
    const url = customUrl || window.location.href;
    const title = pageTitle || document.title;

    GA.trackPageView(url, title);
  }, [pageTitle, customUrl]);
};
